import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route, HashRouter, Redirect } from 'react-router-dom';
import LandingPage from './LandingPage/LandingPage';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import ProtocoloPage from './Protocolo/Protocolo';
import FormPage from './Form/Form';
import RegionSelected from './LandingPage/RegionSelected/RegionSelected';
// import CaletaSelected from './LandingPage/CaletaSelected/CaletasSelected';
import BlueHeader from './common/header/BlueHeader';
import Login from './Login/Login';
import Profile from './Profile/Profile';
import FisherProfile from './FisherProfile/FisherProfile';
import NewProduct from './NewProduct/NewProduct';
import SubscribeFloatModal from './common/SubscribeFloatModal/SubscribeFloatModal';
// import { useEffect } from 'react';
import ConservacionSustentabilidad from './ConservacionSustentabilidad/ConservacionSustentabilidad';
import MarineAreas from './MarineAreas/MarineAreas';
import { UserRequestsPage } from '../admin/pages/UserRequests/UserRequests';
import {ApprovedUsersPage} from '../admin/pages/ApprovedUsers/ApprovedUsers';
import {RejectedUsersPage} from '../admin/pages/RejectedUsers/RejectedUsers'
import {LastSuscribersPage} from '../admin/pages/LastSuscribers/LastSuscribers'
import {ProductListPage} from '../admin/pages/ProductList/ProductList'
import {PendingCommentsPage} from '../admin/pages/PendingComments/PendingComments'
import {StaffListPage} from '../admin/pages/StaffList/StaffList'
import {UserProfilePage} from '../admin/pages/UserProfile/UserProfile'
import {CommentRejectUserPage} from '../admin/pages/CommentRejectUser/CommentRejectUser'
import {StaffLoginPage} from './StaffLogin/StaffLogin';
import {ChangePasswordPage} from '../admin/pages/ChangePassword/ChangePassword'
import {RegisterStaffPage} from '../admin/pages/RegisterStaff/RegisterStaff'

const RouterManager = () => {
    // const history = useHistory();

    const [isAdmin, setIsAdmin] = useState(true);

    return (
        <Router>
            <Switch>
                <HashRouter>
                    {!isAdmin && <BlueHeader />}

                    <Route exact path='/' >
                        <Redirect to="/home" />
                        <Header headerState="home" />
                    </Route>

                    <Route path='/home' >
                        <SubscribeFloatModal />
                        <Header headerState="home" />
                        <LandingPage />
                        <Footer />
                    </Route>
                    <Route path="/region/:id/:regionfilter">
                        <Header headerState="home" />
                        <RegionSelected></RegionSelected>
                        <Footer />
                    </Route>
                    {/* <Route path="/caleta/:id" component={CaletaSelected} />   */}
                    <Route path='/protocolo-covid-19'>
                        <Header headerState="protocolo" />
                        <ProtocoloPage />
                        <Footer />
                    </Route>
                    <Route path='/staff-login'>
                        <StaffLoginPage/>
                    </Route>
                    <Route path='/change-password'>
                        <Login isChangePassword={true}/>
                        <Footer />
                    </Route>
                    <Route path='/new-product'>
                        <Header headerState="home" />
                        <NewProduct />
                        <Footer />
                    </Route>

                    <Route path='/mi-perfil'>
                        <Header headerState="home" />
                        <Profile />
                        <Footer />
                    </Route>

                    <Route path='/conservacion-sustentabilidad'>
                        <Header headerState="conservacion" />
                        <ConservacionSustentabilidad/>
                        <Footer />
                    </Route>

                    <Route path='/areas-marinas'>
                        <Header headerState="marineareas" />
                        <MarineAreas/>
                        <Footer />
                    </Route>

                    <Route path='/perfil-visitante/:_id'>
                        <Header headerState="home" />
                        <FisherProfile />
                        <Footer />
                    </Route>

                    <Route path='/registrar-caleta'>
                        <Header headerState="register" />
                        <FormPage />
                        <Footer />
                    </Route>

                    <Route path='/admin/user-requests'> 
                        <UserRequestsPage />
                    </Route>

                    <Route path='/admin/approved-users'> 
                        <ApprovedUsersPage />
                    </Route>

                    <Route path='/admin/rejected-users'> 
                        <RejectedUsersPage />
                    </Route>

                    <Route path='/admin/last-subscribers'> 
                        <LastSuscribersPage />
                    </Route>
                    
                    <Route path='/admin/product-list'> 
                        <ProductListPage />
                    </Route>

                    <Route path='/admin/comments-to-approve'> 
                        <PendingCommentsPage />
                    </Route>

                    <Route path='/admin/staff-list'> 
                        <StaffListPage />
                    </Route>

                    <Route path='/admin/user-profile'> 
                        <UserProfilePage />
                    </Route>

                    <Route path='/admin/comment-reject-user'> 
                        <CommentRejectUserPage />
                    </Route>

                    <Route path='/admin/change-password'> 
                        <ChangePasswordPage />
                    </Route>
                    
                    <Route path='/admin/register-staff'> 
                        <RegisterStaffPage />
                    </Route>

                    <Route path='/login'>
                        <Login isChangePassword={false} />
                        <Footer />
                    </Route>

                </HashRouter>
            </Switch>
        </Router>
    )
}

export default RouterManager;